import { Box, Button, Typography, useTheme } from "@mui/material";
import CustomTooltipBorder from "../../components/CustomTooltipBorder";

/**
 * Demo component for CustomTooltipBorder
 * Shows different styles and placements of the CustomTooltipBorder component
 *
 * Note: To show a tooltip on a disabled component (like a disabled button),
 * wrap the disabled component in a <span>. This is necessary because
 * tooltips do not work on disabled elements in HTML.
 *
 * Example:
 * <CustomTooltipBorder title={<span>Tooltip for disabled</span>}>
 *   <span>
 *     <Button disabled>Disabled Button</Button>
 *   </span>
 * </CustomTooltipBorder>
 */
const CustomTooltipBorderDemo = () => {
  const theme = useTheme();

  return (
    <Box display="flex" flexWrap="wrap" gap={2}>
      <CustomTooltipBorder
        title={
          <Box p={1}>
            <Typography variant="caption" color="inherit">
              Default border color
            </Typography>
          </Box>
        }
      >
        <Button variant="outlined" size="small" sx={{ borderRadius: 2 }}>
          Default Border
        </Button>
      </CustomTooltipBorder>

      <CustomTooltipBorder
        title={
          <Box p={1}>
            <Typography variant="caption" color="inherit">
              Custom border color
            </Typography>
          </Box>
        }
        borderColor={theme.palette.error.main}
      >
        <Button variant="outlined" size="small" sx={{ borderRadius: 2 }}>
          Red Border
        </Button>
      </CustomTooltipBorder>

      <CustomTooltipBorder
        title={
          <Box p={1}>
            <Typography variant="caption" color="inherit">
              Bottom placement
            </Typography>
          </Box>
        }
        placement="bottom"
        borderColor={theme.palette.success.main}
      >
        <Button variant="outlined" size="small" sx={{ borderRadius: 2 }}>
          Bottom Placement
        </Button>
      </CustomTooltipBorder>

      {/* Example: Tooltip on a disabled button using a span wrapper */}
      <CustomTooltipBorder title={<span>Tooltip for disabled</span>}>
        <span>
          <Button
            variant="outlined"
            size="small"
            sx={{ borderRadius: 2 }}
            disabled
          >
            Disabled Button
          </Button>
        </span>
      </CustomTooltipBorder>
    </Box>
  );
};

export default CustomTooltipBorderDemo;
